// src/api/candidateApi.js
import { apiGet, apiPost } from "./apiClient";

export function fetchAssignedCandidates() {
  return apiGet("/api/candidates/assigned");
}

export function fetchCandidateJwtKey(candidateId) {
  return apiGet(`/api/jwt_key?candidateId=${candidateId}`);
}

export function fetchJobStatusSummary(candidateId, dateFilter) {
  return apiGet(`/api/jobs/status_summary?candidateId=${candidateId}&dateFilter=${dateFilter}`);
}

export function fetchJobsByStatus(candidateId, status, dateFilter, page = 0, pageSize = 100) {
  return apiGet(
    `/api/jobs/by_status?candidateId=${candidateId}&status=${status}&dateFilter=${dateFilter}&page=${page}&pageSize=${pageSize}`
  );
}

/**
 * Fetch the current employee's data.
 * @returns {Promise<Object>} The employee data.
 */
export function fetchCurrentEmployee() {
  return apiGet('/api/employees/me');
}

export function fetchDailyReportSummary(candidateId, employeeId, date) {
  return apiGet(`/api/reports/daily-summary?candidateId=${candidateId}&employeeId=${employeeId}&date=${date}`);
}

export function fetchDailyReportList(candidateId, employeeId, date, status) {
  return apiGet(`/api/reports/daily-list?candidateId=${candidateId}&employeeId=${employeeId}&date=${date}&status=${status}`);
}

export function updateJobStatus(payload) {
  return apiPost("/api/jobs/update_status", payload);
}

export function fetchCandidateSubscription(candidateId) {
  return apiGet(`/api/subscription/${candidateId}`);
}
